import { Col, Container, Row, Stack } from "react-bootstrap";
import { renderSortIcon } from "../helperRenders";

export default function SongCatalogueHeader({ sortConfig, requestSort }) {
    return (
        <Container fluid className="sticky-top">
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none h-100">
                <Col xs xl onClick={() => requestSort("radio_id")} className=" align-content-center">
                    <Stack direction="horizontal">
                        <span>Station</span>
                        <span className="col-1">{renderSortIcon("radio_id", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs xl={1} onClick={requestSort ? () => requestSort("weeks[3].spins") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">This Week</span>
                        <span className="col-1">{renderSortIcon("weeks[3].spins", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs xl={1} onClick={requestSort ? () => requestSort("weeks[2].spins") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Week -1</span>
                        <span className="col-1">{renderSortIcon("weeks[2].spins", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs xl={1} onClick={requestSort ? () => requestSort("weeks[1].spins") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Week -2</span>
                        <span className="col-1">{renderSortIcon("weeks[1].spins", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs xl={1} onClick={requestSort ? () => requestSort("weeks[0].spins") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Week -3</span>
                        <span className="col-1">{renderSortIcon("weeks[0].spins", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs xl={1} onClick={requestSort ? () => requestSort("total_spins") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Total Spins</span>
                        <span className="col-1">{renderSortIcon("total_spins", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs xl={2} onClick={requestSort ? () => requestSort("first_time") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">First Played</span>
                        <span className="col-1">{renderSortIcon("first_time", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xl={1} className=" align-self-center text-center d-none d-xl-block">
                    History
                </Col>
                <Col xl={1} className=" align-self-center text-center d-none d-xl-block">
                    Trend
                </Col>
            </Row>
        </Container>
    );
}
